export default __webpack_public_path__ + "static/poster-1c64fc3de35319463b9240249eb83d0f.png";